
import Constants from '../constants';
import produce from "immer";
import { UpdateArray, UpdateArrayRange } from '../misc/ArrayFuncs';
const roundToTwo = (num) => {
    return +(Math.round(num + "e+2") + "e-2");
}
const initDataState = [];
const GlueRollMeasurements = (state = initDataState, action) => {
    switch (action.type) {
        case Constants.Actions.GlueRollMeasurement.Add:
            return UpdateArray(action.payload, state);
        case Constants.Actions.GlueRollMeasurement.Add_Rollback:
            const ivId = state.findIndex(iv => iv.id === action.meta.newGRM.id);
            if (ivId !== -1) {
                return produce(state, pd => { pd.splice(ivId, 1) });
            } else {
                return state;
            }
        case Constants.Actions.GlueRollMeasurement.Add_Commit:
            return UpdateArray(action.payload?.data, state);
        case Constants.Actions.GlueRollMeasurement.ClearData:
            return initDataState;
        case Constants.Actions.GlueRollMeasurement.Update:
            //Action will have the full plant data
            return state.map((p, ind) => {
                if (p.id === action.payload.id) {
                    return produce(p, pd => { pd[action.payload.name] = action.payload.newValue });
                } else { return p; }
            });

        case Constants.Actions.GlueRollMeasurement.Update_Commit:
            return UpdateArray(action.payload?.data, state);
        case Constants.Actions.GlueRollMeasurement.Update_Rollback:
            //Action will have the full plant data
            return state.map((p, ind) => {
                if (p.id === action.meta.updatePayload.id) {
                    return produce(p, pd => { pd[action.meta.updatePayload.name] = action.meta.updatePayload.oldValue });
                } else { return p; }
            });
        case Constants.Actions.GlueRollMeasurement.GetByParentID:
            return UpdateArrayRange(action.data, state);
        default:
            return state;
    }
}
export default GlueRollMeasurements;